import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home\"><path d=\"M882.149 478.912L781.421 366.75V265.036c0-49.598-40.207-89.805-89.805-89.805-23.478 0-44.667 9.216-60.669 23.966l-46.896-52.218c-37.859-42.158-106.232-42.158-144.092 0L141.863 478.912c-52.419 58.372-9.402 148.252 70.792 149.208v208.177c0 39.955 32.389 72.344 72.344 72.344h137.202V791.394c0-49.598 40.207-89.805 89.805-89.805 49.598 0 89.805 40.207 89.805 89.805V908.64h147.181c39.953 0 72.342-32.389 72.342-72.344V627.42c73.652-7.956 111.005-92.619 60.815-148.508z\" fill=\"#dfc79c\" p-id=\"1095\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/home.svg
// module id = vIvP
// module chunks = 62